import styled, { css } from 'styled-components';
import { themeHelpers } from '@gotamedia/fluffy/theme';
const Anchor = styled.a.withConfig({
  displayName: "style__Anchor",
  componentId: "sc-72e8n0-0"
})(["margin:auto auto auto 0;"]);
const Image = styled.img.withConfig({
  displayName: "style__Image",
  componentId: "sc-72e8n0-1"
})(["width:200px;height:40px;margin:auto 0;", ""], themeHelpers.isSmallDevice(css(["margin:auto 0;width:170px;margin-bottom:10px;&:last-of-type{margin-bottom:0;}"])));
export { Anchor, Image };